import { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, ImageOff, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function Migration() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/migration").then((r) => setItems(r.data)); }, []);

  const statusBadge = (s) => s === "verified"
    ? <span className="inline-flex items-center gap-1 rounded-full bg-green-900/40 px-2.5 py-0.5 text-xs font-bold text-green-400"><CheckCircle2 className="h-3.5 w-3.5" /> Verified</span>
    : <span className="inline-flex items-center gap-1 rounded-full bg-amber-900/40 px-2.5 py-0.5 text-xs font-bold text-amber-400"><AlertTriangle className="h-3.5 w-3.5" /> Awaiting verification</span>;

  return (
    <div>
      <h1 className="font-heading text-2xl font-extrabold uppercase text-white">Content Migration Review</h1>
      <p className="max-w-2xl text-sm text-slate-400">The original website was unreachable during migration, so coaches, staff and sponsors were seeded from known records. Verify each item and upload the correct photographs before publication.</p>
      {items === null ? <Loader2 className="mx-auto mt-16 h-7 w-7 animate-spin text-slate-400" /> : (
        <div className="mt-6 overflow-hidden rounded-xl border border-slate-700">
          <table className="w-full text-left text-sm">
            <thead className="bg-[#0C131F] text-xs uppercase text-slate-400"><tr><th className="p-3">Type</th><th className="p-3">Name</th><th className="p-3">Image</th><th className="p-3">Status</th></tr></thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} className="border-t border-slate-700/60" data-testid={`migration-${it.id}`}>
                  <td className="p-3"><span className="rounded bg-slate-700 px-2 py-0.5 text-[10px] font-bold uppercase text-slate-300">{it.type}</span></td>
                  <td className="p-3 font-semibold text-white">{it.name}</td>
                  <td className="p-3">{it.has_image ? <CheckCircle2 className="h-5 w-5 text-green-400" /> : <span className="inline-flex items-center gap-1 text-xs text-amber-400"><ImageOff className="h-4 w-4" /> Missing</span>}</td>
                  <td className="p-3">{statusBadge(it.status)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
